import { activateApplicationsRoute } from './ActivateApplicationsPage/route';
import { advisorClientAccessRoute } from './AdvisorClientAccessPage/route';
import { advisorRightsRoute } from './AdvisorRightsPage/route';
import { clickToPayRoute } from './ClickToPayPage/route';
import { eventsRoute } from './EventsPage/route';
import { serviceIdentityVerificationRoute } from './IdentityVerificationPage/route';
import { internalControlsRoute } from './InternalControlsPage/route';
import { mobilityApplicationsRoute } from './MobilityApplicationsPage/route';
import { onboardingApplicationsRoute } from './OnboardingApplicationsPage/route';
import { serviceSettingsRoute } from './route';

export const serviceSettingsRoutes = serviceSettingsRoute.addChildren([
	mobilityApplicationsRoute,
	internalControlsRoute,
	activateApplicationsRoute,
	eventsRoute,
	clickToPayRoute,
	advisorRightsRoute,
	advisorClientAccessRoute,
	onboardingApplicationsRoute,
	serviceIdentityVerificationRoute,
]);
